import Link from "next/link";
import { SVGProps } from "react";
import { FaFacebook } from "react-icons/fa";
import { LuLink } from "react-icons/lu";
import {
    RiAppleFill,
    RiDiscordFill,
    RiInstagramFill,
    RiLinkedinBoxFill,
    RiSpotifyFill,
    RiTiktokFill,
    RiYoutubeFill,
} from "react-icons/ri";

interface Props extends SVGProps<SVGSVGElement> {}

export const X = ({ ...props }: Props) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M9.52373 6.77569L15.4811 0H14.0699L8.89493 5.88203L4.7648 0H0L6.24693 8.89552L0 16H1.4112L6.87253 9.78704L11.2352 16H16M1.92053 1.04127H4.08853L14.0688 15.0099H11.9003"
                fill="white"
            />
        </svg>
    );
};

interface SocialLinkProps extends Props {
    href: string;
}
export const SocialLink = ({ href, ...props }: SocialLinkProps) => {
    if (!href) return null;
    let icon;

    switch (href) {
        case href.match(/facebook/)?.input:
            icon = <FaFacebook {...props} />;
            break;

        case href.match(/twitter/)?.input || href.match(/x.com/)?.input:
            icon = <X {...props} />;
            break;

        case href.match(/instagram/)?.input:
            icon = <RiInstagramFill {...props} />;
            break;

        case href.match(/linkedin/)?.input:
            icon = <RiLinkedinBoxFill {...props} />;
            break;

        case href.match(/youtube/)?.input:
            icon = <RiYoutubeFill {...props} />;
            break;

        case href.match(/spotify/)?.input:
            icon = <RiSpotifyFill {...props} />;
            break;

        case href.match(/apple/)?.input:
            icon = <RiAppleFill {...props} />;
            break;
        case href.match(/tiktok/)?.input:
            icon = <RiTiktokFill {...props} />;
            break;
        case href.match(/discord/)?.input:
            icon = <RiDiscordFill {...props} />;
            break;

        default:
            icon = <LuLink {...props} />;
    }

    return (
        <Link href={href} className={props.className} target="_blank">
            {icon}
        </Link>
    );
};
